import type { RouteRecordRaw } from 'vue-router'

export const metlSmithRoutes: RouteRecordRaw[] = [
  {
    path: '/tasks-measures',
    component: () => import('@/layouts/AppLayout.vue'),
    meta: {
      requiresAuth: true,
      module: 'metl-smith',
      moduleDisplayName: 'METL Smith',
    },
    children: [
      {
        path: '',
        name: 'tasks-measures',
        component: () => import('@/modules/metl-smith/views/TasksAndMeasuresView.vue')
      }
    ]
  }
]
